import { ChangeDetectionStrategy, Component, EventEmitter, Output, inject } from '@angular/core';
import { IrisLanguageI } from '../../../../models/IrisLanguage';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StrakitButtonComponent, StrakitTextComponent } from '@ngx-strakit/cdk/controls';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import {
  SkModalBase,
  SkModalContentComponent,
  StrakitButtonPrefixDirective
} from '@ngx-strakit/cdk';

export interface IrisFieldTextTranslationsModalDataI {
  languages: IrisLanguageI[];
  translatedFieldName: string;
  translations: unknown;
}
@Component({
  selector: 'iris-field-text-translations-modal',
  imports: [
    FormsModule,
    TranslateModule,
    StrakitTextComponent,
    SkModalContentComponent,
    StrakitButtonComponent,
    StrakitButtonPrefixDirective,
  ],
  styleUrls: ['./field-text-translations-modal.component.scss'],
  templateUrl: './field-text-translations-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrisFieldTextTranslationsModalComponent extends SkModalBase<IrisFieldTextTranslationsModalComponent, any> {
  readonly data = inject<IrisFieldTextTranslationsModalDataI>(MAT_DIALOG_DATA);

  readonly languages = this.data.languages;
  readonly translatedFieldName = this.data.translatedFieldName;
  set translations(translations: unknown) {
    if (this.translatedFieldName) {
      const translationsModalObject = {};
      for (const languageKey of Object.keys(translations)) {
        translationsModalObject[languageKey] = translations[languageKey][this.translatedFieldName];
      }
      this._translations = Object.assign({}, translationsModalObject);
    } else {
      this._translations = Object.assign({}, translations);
    }
  }

  get translations(): unknown {
    return this._translations;
  }

  _translations: unknown = {};

  @Output() onSetTranslations: EventEmitter<unknown> = new EventEmitter<unknown>();

  constructor() {
    super();
    this.translations = this.data.translations ?? {};
  }

  isNullOrEmpty(str: string): boolean {
    return !str?.trim();
  }

  accept(): void {
    // delete empty properties
    Object.keys(this.translations).forEach((key) => {
      if (this.isNullOrEmpty(this.translations[key])) {
        delete this.translations[key];
      }
    });

    if (this.translatedFieldName) {
      const translationsResult = {};
      for (const languageKey of Object.keys(this.translations)) {
        translationsResult[languageKey] = { [this.translatedFieldName]: this.translations[languageKey] };
      }
      this.onSetTranslations.emit(translationsResult);
    } else {
      this.onSetTranslations.emit(this.translations);
    }

    this.closeWithoutResult();
  }

}
